<template>
  <form @submit.prevent="send()">
    <!-- <input type="hidden" name="action" value="send_contact_form" /> -->
    <!-- <input type="text" class="website_hp" name="website_hp" /> -->
    <div class="alert hidden" id="contact-form-msg"></div>
    <div class="form-group">
      <input
        type="text"
        class="form-control first-name text-field text-capitalize"
        name="first-name"
        required
        :placeholder="l('ime')"
        v-model="form.first_name"
      />
      <input
        type="text"
        class="form-control last-name text-field text-capitalize"
        name="last-name"
        required
        :placeholder="l('prezime')"
        v-model="form.last_name"
      />
      <div class="clearfix"></div>
    </div>
    <div class="form-group">
      <input
        type="tel"
        required
        class="form-control telephone text-field text-capitalize"
        name="telephone"
        :placeholder="l('telefon')"
        v-model="form.phone"
      />
    </div>
    <div class="form-group">
      <input
        type="email"
        required
        class="form-control email text-field text-capitalize"
        name="email"
        :placeholder="l('email')"
        v-model="form.email"
      />
    </div>
    <div class="form-group">
      <textarea
        required
        class="form-control message"
        name="message"
        :placeholder="l('poruka')"
        v-model="form.message"
      ></textarea>
    </div>
    <input
      type="submit"
      class="btn submit-message"
      name="submit-message"
      :value="l('posalji_poruku')"
    />
  </form>
</template>

<script>
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import data from "../../mixins/site";
export default {
  props: ["langs"],
  components: {
    Loading
  },
  mixins: [data],
  data() {
    return {
      isLoading: false,
      form: {
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        message: ""
      }
    };
  },
  methods: {
    clear() {
      for (let i in this.form) {
        this.form[i] = "";
      }
    },
    async send() {
      this.isLoading = true;
      setTimeout(() => {
        this.$swal("Mail poslan, odgovoricemo vam uskoro");
        this.isLoading = false;
      }, 2000);

      let resp = await this.sts(
        "post",
        this.domain + "site/email",
        this.form,
        ""
      );

      this.clear();
    }
  }
};
</script>

<style>
::-webkit-input-placeholder {
  text-transform: initial;
}

:-moz-placeholder {
  text-transform: initial;
}

::-moz-placeholder {
  text-transform: initial;
}

:-ms-input-placeholder {
  text-transform: initial;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/components/site/MailSend.vue